import React from 'react';

// Holds preview HTML written by the framefield iframe editor (as a sibling
// block property). Never edited directly, so it only renders a hidden input.
// The input needs its dataPath as id so the framefield can pick the value up
// via its DOM fallback (getCurrentBlockValuesFromDom).
class MavuPreviewHtmlField extends React.Component {
    render() {
        const {
            dataPath,
            name,
            value,
        } = this.props;

        return (
            <input
                id={dataPath}
                name={name}
                readOnly={true}
                type="hidden"
                value={value == null ? '' : value}
            />
        );
    }
}

export default MavuPreviewHtmlField;
